export type ContactType = 'Email Address' | 'Phone Number';

export class ContactTypes {
    public static readonly EMAIL_ADDRESS: ContactType = 'Email Address';
    public static readonly PHONE_NUMBER: ContactType = 'Phone Number';
}